import { DEFAULT_SETTINGS } from 'core/api/settings';
import * as Yup from 'yup';

export interface FormValues {
  days: number;
}

export const defaultValues: FormValues = DEFAULT_SETTINGS.paymentusSettings;

const detailsFields = {
  days: Yup.number().required('Field is required'),
};

export const getValidationSchema = () => {
  return Yup.object({
    ...detailsFields,
  });
};
